export const UPLOAD_RESULTS_FAILURE = 'UPLOAD_RESULTS_FAILURE';

export const uploadResultsFailure = error => ({
    type: UPLOAD_RESULTS_FAILURE,
    payload: error,
    error: true,
});
